// src/components/InfographicMagnifier.js

import React, { useState } from 'react';
// We'll add CSS import and link later

/**
 * Component to display an infographic that expands on click.
 * Assumes the image is placed in the /public folder and referenced by a public path.
 * @param {object} props
 * @param {string} props.url - The public URL of the infographic image.
 * @param {string} props.alt - The alt text for the infographic image.
 */
const InfographicMagnifier = ({ url, alt }) => {
  const [isMagnified, setIsMagnified] = useState(false); // State to track if the image is magnified

  // Don't render anything if no URL is provided
  if (!url) {
    return null;
  }

  // Function to toggle the magnified state
  const toggleMagnify = () => {
    setIsMagnified(!isMagnified);
    // Optional: Add body class to prevent scrolling when magnified
    if (!isMagnified) {
        document.body.classList.add('no-scroll');
    } else {
        document.body.classList.remove('no-scroll');
    }
  };


  return (
    <> {/* Use a fragment to return multiple elements if needed */}

      {/* Initial contained view */}
      {/* Add a class for styling this container and the image inside */}
      <div className="infographic-container" onClick={toggleMagnify} style={{ cursor: 'pointer' }}>
        <img src={url} alt={alt} className="infographic-thumbnail" /> {/* Add class for styling */}
        {/* Optional: Add an icon or text indicating it's clickable/magnifiable */}
        {/* <div className="magnify-overlay-icon">🔍 Click to Zoom</div> */}
      </div>

      {/* Magnified Overlay View */}
      {isMagnified && (
        // Add a class for styling the overlay and the image inside
        <div className="infographic-overlay" onClick={toggleMagnify}>
          <img src={url} alt={alt} className="infographic-magnified" /> {/* Add class for styling */}
           {/* Optional: Add a close button */}
           {/* <button className="infographic-close-button">X</button> */}
        </div>
      )}

    </>
  );
};

export default InfographicMagnifier;